<script setup lang="ts">
import OneButton from '@/common/components/molecules/button/OneButton.vue';
import MenuSearchError from '@/common/components/organisms/menuSearch/menuSearchContent/MenuSearchError.vue';
import MenuSearchRecent from './MenuSearchRecent.vue';
import MenuSearchFavoriteDashboard from './MenuSearchFavoriteDashboard.vue';

import { setup } from './menuSearchDefault.setup';

const {
  t,
  favoriteDashboardList,
  isHistoryMenuError,
  favoriteDashboardErrorIcon,
  favoriteDashboardErrorMessage,
  onViewAllFavoriteDashboard,
} = setup();
</script>

<template>
  <div class="menu-search-default">
    <div class="menu-search-default__section">
      <h2 class="menu-search-default__title">{{ t('WORD.GNB_SEARCH_DEFAULT_RECENT_TITLE') }}</h2>
      <menu-search-recent v-if="!isHistoryMenuError" />
      <menu-search-error v-else />
    </div>
    <div class="menu-search-default__section">
      <h2 class="menu-search-default__title menu-search-default__title--favorite-dashboard">
        {{ t('WORD.GNB_SEARCH_DEFAULT_FAVORITE_DASHBOARD_TITLE') }}
        <one-button
          type="text"
          shape="border"
          size="xsmall"
          right-icon="icon-arrow-right"
          class="menu-search-default__sub-button"
          @click="onViewAllFavoriteDashboard"
          >{{ t('WORD.VIEW_ALL') }}
        </one-button>
      </h2>
      <menu-search-favorite-dashboard v-if="favoriteDashboardList.length" />
      <menu-search-error
        v-else
        :message="favoriteDashboardErrorMessage"
        :icon="favoriteDashboardErrorIcon"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.menu-search-default {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 356px;

  &__section {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    height: 32px;
    padding: 16px 8px 4px;
    font-weight: 500;
    color: var(--color-gray-03-09);

    @include typography('body-2');

    &--favorite-dashboard {
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: space-between;

      .menu-search-default__sub-button,
      .menu-search-default__sub-button:hover {
        width: fit-content !important;
        padding: 6px 0 4px 10px !important;
        border: none;

        :deep(.one-button__right-icon) {
          background-color: var(--color-blue-05-05) !important;
        }
      }
    }
  }

  .menu-search-recent,
  .menu-search-favorite-dashboard {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-height: 140px;
  }
}
</style>
